<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset="">
                  
                    <h5 class="m-0 "><a class="fw-medium d-flex align-items-center text-black gap-2" (click)="goBack()"> <mat-icon class="back-arrow text-black"  aria-label="Example home icon" fontIcon="west"></mat-icon>{{'BACK' | translate }}</a></h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4 fw-light">{{'CHANGE_EMAIL' | translate }}</h2>
                    <form class="login-form" [formGroup]="ChangeEmailForm" (ngSubmit)="form.form.valid"  #form="ngForm">
                        <div class="mb-3">
                            <mat-label>{{'CURRENT_EMAIL' | translate }}</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'CURRENT_EMAIL' | translate" formControlName="currentEmail" >
                        </div>
                        <div class="mb-3">
                            <mat-label>{{'NEW_EMAIL_PLACEHOLDER' | translate }}</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'NEW_EMAIL_PLACEHOLDER' | translate" formControlName="newEmail">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || ChangeEmailForm.get('newEmail')?.touched) && ChangeEmailForm.controls['newEmail'].errors?.['required']">
                                {{'EMAIL_REQUIRED' | translate }}
                            </mat-error>
                            <mat-error class="text-danger"
                            *ngIf="form.submitted && ChangeEmailForm.controls['newEmail'].errors?.['pattern']">
                               {{'EMAIL_INVALID_MSG' | translate }}
                            </mat-error>
                            <mat-error class="text-danger"
                            *ngIf="form.submitted && ChangeEmailForm.controls['newEmail'].value == ChangeEmailForm.controls['currentEmail'].value">
                                {{'EMAIL_NOT_MATCHED_MSG' | translate }}
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <mat-label>{{'REENTER_NEW_EMAIL' | translate }}</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'REENTER_NEW_EMAIL'| translate " formControlName="confirmEmail">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || ChangeEmailForm.get('confirmEmail')?.touched) && ChangeEmailForm.controls['confirmEmail'].errors?.['required']">
                                {{'EMAIL_REQUIRED' | translate }}
                            </mat-error>
                            <mat-error class="text-danger"
                            *ngIf="form.submitted && ChangeEmailForm.controls['confirmEmail'].errors?.['pattern']">
                                {{'EMAIL_INVALID_MSG' | translate }}
                            </mat-error>
                        </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="OnchangeEmail()">{{'CHANGE_YOUR_EMAIL' | translate }}</button>
                    </form>
                </div>
            </div>
         
        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height" [ngClass]="userData.UserTypeId === 3 ? 'firmChangePassword-bg' : 'changePassword-bg'">
              <p>&nbsp;</p>
            </div>
        
        </div>
    </div>
</div>

